var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTelegram = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7767 2.47788L1.95669 7.03588C1.15002 7.35988 1.15469 7.80988 1.80869 8.01055L4.84336 8.95721L11.8647 4.52721C12.1967 4.32521 12.5 4.43388 12.2507 4.65521L6.56202 9.78921H6.56069L6.56202 9.78988L6.35269 12.9179C6.65936 12.9179 6.79469 12.7772 6.96669 12.6112L8.44069 11.1779L11.5067 13.4425C12.072 13.7539 12.478 13.5939 12.6187 12.9192L14.6314 3.43388C14.8374 2.60788 14.316 2.23388 13.7767 2.47788Z",
    fill: "#0088CC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_telegram.ea74a74a1878e617bb4e62fda27907d2.svg";